import { Badge, Gutter } from "@qw/ui";
import type { ComponentProps, FC } from "react";
export const Section: FC<ComponentProps<"div">> = ({ children, ...props }) => (
  <div className="border-t border-border/40 first:border-t-0 p-2 space-y-2" {...props}>
    {children}
  </div>
);

export const SectionHeader: FC<ComponentProps<"h5"> & { count: number }> = ({ children, count, ...props }) => (
  <h5 className="flex font-medium gap-3 items-center p-3 text-xs" {...props}>
    <Gutter className="w-4">
      <Badge variant="secondary" type="square" size="2xs">
        {count}
      </Badge>
    </Gutter>
    {children}
  </h5>
);
